import { render, staticRenderFns } from "./CustomAttributeDropDown.vue?vue&type=template&id=4aa84dee&scoped=true&"
import script from "./CustomAttributeDropDown.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeDropDown.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributeDropDown.vue?vue&type=style&index=0&id=4aa84dee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa84dee",
  null
  
)

export default component.exports